<div [class]="'table-loading ' + type">
  <mat-spinner strokeWidth="3" [diameter]="diameter"></mat-spinner>
</div>